import { render, staticRenderFns } from "./rollDetail.vue?vue&type=template&id=79354d6c&scoped=true&"
import script from "./rollDetail.vue?vue&type=script&lang=js&"
export * from "./rollDetail.vue?vue&type=script&lang=js&"
import style0 from "./rollDetail.vue?vue&type=style&index=0&id=79354d6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79354d6c",
  null
  
)

export default component.exports